import filters from 'lib/filters'

const { initialValueRange } = filters

const reconstructArrayFilters = arrayFilters => {
  const {
    Finalidade,
    Situação,
    'Tipo de Compra': tipoCompra,
    'Tipo de Imóvel': tipoImovel,
    'Tipo de Venda': tipoVenda,
    vendedor,
    Desagio,
  } = arrayFilters

  return {
    goal: {
      currentFilters: Finalidade,
      field: 'Finalidade',
    },
    propertyStatus: {
      currentFilters: Situação,
      field: 'Situação',
    },
    purchaseType: {
      currentFilters: tipoCompra,
      field: 'Tipo de Compra',
    },
    propertyType: {
      currentFilters: tipoImovel,
      field: 'Tipo de Imóvel',
    },
    saleType: {
      currentFilters: tipoVenda,
      field: 'Tipo de Venda',
    },
    seller: {
      currentFilters: vendedor,
      field: 'vendedor',
    },
    desagio: {
      currentFilters: Desagio,
      field: 'Desagio',
    },
  }
}

const reconstructToggleFilters = toogleFilters => {
  const { visits, noLegalActions, noDebts, surroundingsSearch } = toogleFilters

  return {
    visit: {
      status: visits,
      title: visits && 'Permite visitar',
      field: 'visits',
    },
    legalAction: {
      status: noLegalActions,
      title: noLegalActions && 'Sem ações judiciais',
      field: 'noLegalActions',
    },
    debts: {
      status: noDebts,
      title: noDebts && 'Imóvel sem dívidas',
      field: 'noDebts',
    },

    surroundingSearch: {
      status: surroundingsSearch,
      title: surroundingsSearch && 'Busca na região',
      field: 'surroundingsSearch',
    },
  }
}

const reconstructIntegerFilters = integerFilters => {
  const { valueRange } = integerFilters

  return {
    reconstructedValueRange: {
      title: `R$ ${valueRange.min} - R$ ${valueRange.max}`,
      resetValue: { max: initialValueRange.max, min: initialValueRange.min },
      field: 'valueRange',
      show:
        valueRange &&
        (valueRange.max !== initialValueRange.max ||
          valueRange.min !== initialValueRange.min),
    },
  }
}

/**
 * Restructure filters from store in order to properlly render them as tags, returning them as objects with the proper keys to be handled by TagSetContainer component
 * @param {object} arrayFilters Filters from $filter.filters at store/filters, beeing those which have an structure of [{}]
 * @param {object} toogleFilters Filter 'visits, noLegalActions, noDebts' from $filter.filters at store/filters, beeing those which contains a simple boolean as key
 * @param {object} integerFilters Filter 'desagio, valueRange' from $filter.filters at store/filters, beeing those which integer as key, either inside an {}, or as a simple key
 * @returns {object} Returns each of the objects received as params, inside an object and properlly treated in order to be used on TagSetContainer component
 * @author Leandro Parisi
 * @since 2020.03.12
 */
const parseTagSetFilters = (arrayFilters, toogleFilters, integerFilters) => {
  const reconstructedArrayFilters = reconstructArrayFilters(arrayFilters)

  const reconstructedToggleFilters = reconstructToggleFilters(toogleFilters)

  const reconstructedIntegerFilters = reconstructIntegerFilters(integerFilters)

  return {
    reconstructedArrayFilters,
    reconstructedToggleFilters,
    reconstructedIntegerFilters,
  }
}

export default parseTagSetFilters
